<met-page-layout>
  <div>
    <h3>Zusätzliche Stationsinformationen</h3>
  </div>
  <div class="additional-station-info">
    <div class="control-line" style="margin-bottom: 20px;">
      <div *ngIf="canEditStationInfo">
        <met-button buttonText="Info hinzufügen" (click)="addInfo()">Info hinzufügen ></met-button>
      </div>
    </div>
    <table mat-table [dataSource]="stationInfos">

      <ng-container matColumnDef="infoLabel">
        <th mat-header-cell *matHeaderCellDef>Bezeichnung</th>
        <td mat-cell *matCellDef="let element">{{ element.infoLabel }}</td>
      </ng-container>

      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef> Icon </th>
        <td mat-cell *matCellDef="let element">
          <div *ngIf="(imageUrls$ | async) as imageUrls">
            <img
              [src]="getImageUrlForLabel(element.infoLabel, imageUrls)"
              width="40"
              height="40"
              (error)="onImageError($event)"
            />
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="isactive">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">
          <mat-slide-toggle
            [checked]="element.active"
            [disabled]="!canEditStationInfo || isSaving[element.id]"
            (change)="onToggleActive(element, $event)"
            [class.active-green]="element.active"
            [class.inactive-red]="!element.active">

            {{ element.active ? 'Aktiv' : 'Inaktiv' }}
          </mat-slide-toggle>
          <mat-progress-spinner
            *ngIf="isSaving[element.id]"
            mode="indeterminate"
            diameter="18"
            style="margin-left:8px">
          </mat-progress-spinner>
        </td>
      </ng-container>

      <ng-container *ngIf="canEditStationInfo || canDeleteStationInfo" matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Aktionen </th>
        <td mat-cell *matCellDef="let element">
          <button *ngIf="canEditStationInfo" mat-icon-button (click)="editInfo(element)" style="color: #6e6e6e;">
            <mat-icon>edit</mat-icon>
          </button>
          <button *ngIf="canDeleteStationInfo" mat-icon-button (click)="deleteInfo(element.id)" style="color: #6e6e6e;">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>

    </table>

    <mat-paginator
      [length]="length"
      [pageSizeOptions]="pageSizes"
      [pageSize]="currentPageSize"
      [pageIndex]="pageNo"
      (page)="onPageChange($event)">
    </mat-paginator>
  </div>
</met-page-layout>
